import React, { useRef, useEffect } from 'react';

const BlockquoteBlock = ({ block, isActive, onChange, isRTL = false, language = 'en' }) => {
  const textareaRef = useRef(null);
  const { text = '', author = '' } = block.content || {};

  useEffect(() => {
    if (isActive && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isActive]);

  useEffect(() => {
    // Auto-resize textarea
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [text]);

  const textDirection = isRTL ? 'rtl' : 'ltr';
  const textAlign = isRTL ? 'text-right' : 'text-left';
  const borderClass = isRTL ? 'border-r-4 pr-6' : 'border-l-4 pl-6';
  const quotePlaceholder = isRTL ? 'הזינו ציטוט...' : 'Enter quote...';
  const authorPlaceholder = isRTL ? '— שם המחבר' : '— Author name';

  return (
    <div className={`blockquote-block ${borderClass} border-primary-500 py-2`}>
      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => onChange({ text: e.target.value })}
        placeholder={quotePlaceholder}
        dir={textDirection}
        className={`w-full bg-transparent border-none outline-none resize-none text-xl text-gray-700 italic leading-relaxed min-h-[1.5em] ${textAlign}`}
        rows={1}
      />
      <div className="mt-2">
        <input
          type="text"
          value={author}
          onChange={(e) => onChange({ author: e.target.value })}
          placeholder={authorPlaceholder}
          dir={textDirection}
          className={`w-full bg-transparent border-none outline-none text-sm text-gray-500 ${textAlign}`}
        />
      </div>
    </div>
  );
};

export default BlockquoteBlock;
